import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { AgentDto } from "@/features/kyc/api/dto";

/**
 * Lookup agent par sub Keycloak
 * (`GET /Agents/by-keycloak/{keycloakUserId}`, guide v2.4 §6.2).
 *
 * Rôles : `flashpay-agents`, `flashpay-service`. Utilisé pour récupérer
 * `agentId` et `agentPartyId` depuis la session de l'agent connecté
 * (parcours Non-Member : `NonMemberCodes/redeem`, QR agent `/agent/me`).
 */
export const useAgentByKeycloak = (
  keycloakUserId: string | null | undefined,
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_AGENT_BY_KEYCLOAK(keycloakUserId ?? ""),
    queryFn: () =>
      fetchDataGet<AgentDto>({
        url: kycEndpoints.agents.byKeycloak(keycloakUserId as string),
      }),
    enabled: enabled && Boolean(keycloakUserId),
    staleTime: 5 * 60 * 1000,
  });
